import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { useState } from 'react'

export function AddDocumentTagModal({
  open,
  setOpen,
  onAdd,
}: {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  onAdd: (name: string) => void
}) {
  const [name, setName] = useState('')

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={() => setOpen(false)}
      open={open}
      slotProps={{
        paper: {
          sx: {
            minHeight: '250px',
          },
        },
      }}
    >
      <DialogTitle>Add New Document Tag</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Document Tag Name"
          size="small"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ my: 2 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            disabled={!name}
            onClick={() => {
              onAdd(name)
              setName('')
              setOpen(false)
            }}
            variant="contained"
          >
            Add
          </Button>
        </>
      </DialogActions>
    </Dialog>
  )
}
